import React, { useEffect, useRef } from 'react';

export function Checkbox({ indeterminate = false, className = '', ...props }) {
  const ref = useRef(null);
  useEffect(() => {
    if (ref.current) ref.current.indeterminate = indeterminate;
  }, [indeterminate]);
  return (
    <input
      ref={ref}
      type="checkbox"
      className={`tw-m-0 tw-h-4 tw-w-4 tw-shrink-0 tw-cursor-pointer tw-rounded tw-border-neutral-300 tw-accent-brand-600 disabled:tw-cursor-not-allowed disabled:tw-opacity-50 ${className}`}
      {...props}
    />
  );
}
